package com.ives.components.messagehandler;

import haxe.ds.StringMap;
import com.ives.modules.measurements.MeasurementData;
import js.Browser;
import js.html.MessageEvent;

import com.er453r.hxcompo.Component;

import com.ives.modules.compare.Compare;
import com.ives.modules.roi.ROI;
import com.ives.modules.roi.ROIData;
import com.ives.modules.measurements.Measurements;
import com.ives.modules.ModuleEvent;
import com.ives.utils.Log;

class MessageHandler extends Component{
	public static var userName:String = "";
	public static var externalMeasurements:StringMap<MeasurementData> = new StringMap<MeasurementData>();

	public static var instance:MessageHandler;

	public static inline var COMPARE_IDS:String = "compare_ids";
	public static inline var LOAD:String = "load";
	public static inline var CLOSE:String = "close";
	public static inline var VIEWER:String = "viewer";
	public static inline var USER_NAME:String = "username";

	public function new(){
		if(instance != null)
			throw "MessageHandler is a singleton!";

		instance = this;

		Browser.window.addEventListener("message", function(event:MessageEvent){
			Log.debug('Recieved event from ${event.origin}: ${event.data}');

			if(event.data.action != null){
				var roiData:ROIData = cast event.data;

				dispatch(VIEWER, new ModuleEvent(ROI.ROI_MESSAGE, roiData.points, [roiData.description, roiData.action]));
			}

			if(event.data.type == MeasurementData.MEASUREMENT_DATA){
				Log.debug("Received external measurement");

				var measurementData:MeasurementData = cast event.data;

				externalMeasurements.set(measurementData.drawingId, measurementData);

				dispatch(VIEWER, new ModuleEvent(Measurements.MEASUREMENTS_EXTERNAL, measurementData.points, [measurementData.imageId, measurementData.measurementType, measurementData.drawingId]));
			}

			var messageData:MessageData = cast event.data;

			if(messageData.type == COMPARE_IDS){
				Log.debug('Compare ids...');

				Compare.allowedIds = messageData.ids;

				if(Compare.instance != null)
					Compare.instance.refresh();
			}

			if(messageData.type == LOAD){
				Log.debug('Loading from message...');

				dispatch(LOAD, messageData);
			}

			if(messageData.type == CLOSE){
				Log.debug('Closing from message...');

				dispatch(CLOSE);
			}

			if(messageData.type == USER_NAME){
				Log.debug('Setting user name to: ${messageData.id}');

				MessageHandler.userName = messageData.id;
			}

			if(messageData.type == VIEWER){
				Log.debug('Viewer event...');

				dispatch(VIEWER, messageData.event);
			}
		});
	}

	public static function send(data:Dynamic, ?target:String = '*'){
		if(Browser.window.top == Browser.window)
			return;

		Browser.window.top.postMessage(data, target);
	}

	public static function sendReady(){
		send('ready', '*');
	}

	public static function sendMessage(messageData:MessageData){
		send(messageData, '*');
	}

	public static function sendEvent(event:ModuleEvent){
		Log.debug('Sending: ${event.type} (origin: ${event.origin})');

		if(Browser.window.top == Browser.window)
			return;

		event.external = true;

		var messageData:MessageData = new MessageData();

		messageData.type = VIEWER;
		messageData.event = event;

		send(messageData, '*');
	}
}

class MessageData {
	public var type:String;
	public var source:String;
	public var id:String;
	public var event:ModuleEvent;
	public var ids:Array<String>;

	public function new(?type:String, ?id:String, ?source:String, ?event:ModuleEvent, ?ids:Array<String>){
		this.type = type;
		this.id = id;
		this.source = source;
		this.event = event;
		this.ids = ids;
	}
}
